import axios from "axios";
import env from "../env";

const api_url = env.API_URL;

export const getUserDetails = async (token:any) => {
    try {
        const response = await axios.get(`${api_url}test/user-details`,{
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getAdminDetails = async (token:any) => {
    try {
        const response = await axios.get(`${api_url}super-admin/admins`,{
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const createAdmin = async (token:any, adminDetails: any) => {
    try {
        const response = await axios.post(`${api_url}super-admin`, adminDetails, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const updateAdmin = async (token:any, adminDetails: any) => {
    try {
        const response = await axios.put(`${api_url}super-admin`, adminDetails, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const deleteAdmin = async (token:any, adminId: string) => {
    try {
        const response = await axios.delete(`${api_url}super-admin/${adminId}`, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const resetAdminPassword = async (token:any, email:any, password: any) => {
    try {
        const response = await axios.post(`${api_url}super-admin/reset-password?Email=${email}&NewPassword=${password}`,null, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const resetStudentPassword = async (token:any, email:any, password: any) => {
    try {
        const response = await axios.post(`${api_url}super-admin/reset-password-student?Email=${email}&NewPassword=${password}`,null, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const resetInsPassword = async (token:any, email:any, password: any) => {
    try {
        const response = await axios.post(`${api_url}super-admin/reset-password-instructor?Email=${email}&NewPassword=${password}`,null, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const raiseTicket = async (token:any, ticketDetails: any) => {
    try {
        const response = await axios.post(`${api_url}ticketing-operations`, ticketDetails, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getTicketsByUserId = async (token:any, userId: string) => {
    try {
        const response = await axios.get(`${api_url}ticketing-operations/by-student-id?studentId=${userId}`, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getAllTickets = async (token:any) => {
    try {
        const response = await axios.get(`${api_url}ticketing-operations`, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const markTicketAsAddressed = async (token:any, body: any) => {
    try {
        const response = await axios.put(`${api_url}ticketing-operations`, body, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}